import logo from './logo.svg';
import './vars.css';
import './ui.css';
import './styles.css';
import CSS from './utils/CSS';
import Card from './ui/Card';
import Console from './components/Console';
import { useEffect, useRef, useState } from 'react';
import PubSub, { pubCall } from './utils/PubSub';
import Session from './hooks/useSession';
import Input from './ui/Input';
import kb from "./hooks/KeyboardManager";
import Globals from './hooks/Globals';
import { signal, useSignal } from '@preact/signals-react';
import { getRouteLabel, ROUTES } from './utils/Routes';
import Alert from './ui/Alert';
import TextButton from './ui/TextButton';
import Float from './ui/Float';
import LiveToggle from './utils/LiveToggle';
import Authentication from './components/authentication/Authentication';
import Button from './ui/Button';
import Cookies from "js-cookie";
import Select from './ui/Select';
import Space from './ui/Space';
import { ENUMS } from './utils/Enums';
import { signal as createSignal } from "@preact/signals-react";
import { useBackAsEscape } from './utils/BackButtonTrap';
import { kbdEvent } from './utils/Utils';
import { KBD } from './utils/Keybindings';
import { v4 as uuidv4 } from 'uuid';
export const appSignal = createSignal({
  title: "Main Menu",
  route: "",
  session: {},
  inventory_search: "Search Results",
  show_back: false,
  controller: "home"
});
export const getSignal = () => appSignal.value;
export const setSignal = (val) => { appSignal.value = val; };
export const activeComponent = signal("home");
window.ac = "home";
function App() {


 
  let mode = process.env.REACT_APP_MODE || "";
  if (mode === "beta") {
    window.beta = true;
  }


  const signal = appSignal;

  useBackAsEscape(() => {
    kbdEvent(KBD.ESCAPE)
  })




  window.tab_id = sessionStorage.getItem('tab_id');

  if (!window.tab_id) {
    window.tab_id = uuidv4();
    sessionStorage.setItem('tab_id', window.tab_id);
  }





  const [v, setV] = useState("email");

  window.k = kb;
  const refs = useRef({});
  let _bmstate;
  window.bm_state = {
    get value() {
      return _bmstate;
    },
    set value(newState) {
      console.log("%c Route: " + newState, "color:lightgreen;");
      const url = new URL(window.location.href);
      url.searchParams.set("st", newState);

      // use pushState or replaceState depending on what you want

      _bmstate = newState;
      signal.value = { ...signal.value, "route": _bmstate }
      if (getRouteLabel(_bmstate)) {
        console.log("label changed")
        signal.value = { ...signal.value, "title": getRouteLabel(_bmstate) }
      }

    }
  };

  useEffect(() => {
    window.bm_state.value = ROUTES.AUTHENTICATION.LOGIN;
  }, []);



  const [globals, setGlobals] = useState(false);
  const [status, setStatus] = useState("authenticating") // authenticating, connecting, connected, idle






  // Stop defocusing on mouse down.. This is a broad brush approach...
  useEffect(() => {
    const handleMouseDown = (event) => {
      if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
        // Don't block if it's an input or textarea
      } else {
        if (document.activeElement.tagName !== 'INPUT' && document.activeElement.tagName !== 'TEXTAREA') {
          // No input or textarea selected, no need to block
        } else {
          event.preventDefault();
        }
      }
    };

    document.addEventListener("mousedown", handleMouseDown);
    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, []);




  if (window.location.pathname.includes("switcher")) {
    const _split = window.location.pathname.split('/');
    const _session = _split[_split.length - 1];
    Cookies.set("bmo_session_id", _session, { expires: 14 });
    window.history.replaceState(null, '', '/');
    setTimeout(() => {
      window.location.reload();
    }, 1000)
    return <>switching...</>;
  }







  // return (
  //   <Space>


  //     <Select
  //       ref={refs}
  //       value={v} // internal value
  //       onChange={(val) => setV(val)}

  //       options={ENUMS.DEFAULT_OPTIONS}
  //       placeholder="Select an option"
  //     />

  //     <Input edit />
  //   </Space>
  // )





  return (

    <div className="App">
      <div style={{ "position": "absolute", "width": "100%", "height": "0px", "left": "0px", "top": "0px", "outlineOffset": "-4px", "borderTop": (Cookies.get("socket_url")) ? "4px solid #9932CC" : "none", "zIndex": "99999", "pointerEvents": "none" }}>&nbsp;</div>


      <div style={{ "textAlign": "center" }} className='mobile'><Button onClick={() => window.open("https://m.bmo.bookmanager.com/", "_self")}>
        Go to mobile BMO
      </Button>
        {(window?.screen?.availWidth > 1360 && <div style={{ "color": "#ffcc7c", "padding": "20px" }}>
          <small>*Your screen has enough space to view BMO, but you need to expand your browser window fully to access it properly</small></div>)}
      </div>
      <div className='desktop'>
        <LiveToggle />
        <Globals value={[globals, setGlobals]}>
          {(status === "idle" && <div onClick={() => setStatus("connecting")}>
            <div style={{ "width": "500px" }}>
              <div className="shim" /><div className="shim" />
              <Alert
                title="Disconnected"
                description={<>Bookmanager is currently <strong>disconnected</strong>, and functions are temporarily unavailable. <div className="shim" /><div className="shim" /><div className="shim" />This may be due to a another terminal taking over this station. <div className="shim" /><div className="shim" /><div className="shim" />For immediate assistance, please contact support. <div className="shim" />We apologize for any inconvenience.
                  <Float>
                    <div>&nbsp;</div>
                    <TextButton><div style={{ "height": "20px", "lineHeight": "20px" }}>Reconnect</div></TextButton>
                  </Float>
                </>}
              />
            </div>
          </div>)}
          {(status === "authenticating" && <Authentication status={status} setStatus={setStatus} signal={signal} />)}
          {((status !== "idle" && status !== "authenticating") && <PubSub setStatus={setStatus} status={status} signal={signal} />)}
          {(status === "connected" && <Console signal={signal} />)}
        </Globals>
      </div>
    </div>
  );
}

export default App;
